import {
  ClientClassificationType,
  ClientTypeClient,
  LegalClientCategoryType,
  LegalClientEconomicSectorType,
} from 'api/types/entity';
import { yesOrNotSelectValidation } from 'helpers';
import { ObjectSchema, object, TypedForm, selectSchema } from 'libs/form';
import {
  BaseGeneralFormType,
  baseGeneralSchema,
} from 'modules/client/common/forms/baseGeneralForm';
import { Maybe } from 'types/maybe';
import { SelectType } from 'types/selectType';
import { YesOrNoSelectType } from 'types/yesOrNo';

export interface GeneralFormType {
  general: BaseGeneralFormType & {
    category?: Maybe<SelectType<LegalClientCategoryType>>;
    economicSector?: Maybe<SelectType<LegalClientEconomicSectorType>>;
    clientType?: Maybe<SelectType<ClientTypeClient>>;
    classification?: Maybe<SelectType<ClientClassificationType>>;
    isInsider?: Maybe<YesOrNoSelectType>;
  };
}

export const generalSchema: ObjectSchema<GeneralFormType> = object({
  general: object({
    category: selectSchema(Object.values(LegalClientCategoryType))
      .nullable()
      .default(null),
    economicSector: selectSchema(Object.values(LegalClientEconomicSectorType))
      .nullable()
      .default(null),
    clientType: selectSchema(Object.values(ClientTypeClient))
      .nullable()
      .default(null),
    classification: selectSchema(Object.values(ClientClassificationType))
      .nullable()
      .default(null),
    isInsider: yesOrNotSelectValidation.nullable().default(null),
  }).concat(baseGeneralSchema),
});

export const { Field, Form, useFormContext, Submit } =
  TypedForm<GeneralFormType>();
